module.exports = __webpack_public_path__ + "img/horizontal_4_4_pp12_5010.2fd67a11.png";